import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import styles from './LoadingOverlay.module.scss';

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => {
  return (
    <div className={styles.overlay}>
      <Spinner size={SpinnerSize.large} label={message} />
    </div>
  );
};
